import { defaultMarkerOptions, } from '@lc/libmap-types';
import { Marker } from 'maplibre-gl';
import { convertLatLngToLngLatLike, convertLngLatToLatLng } from '../convert.js';
import { dragEvent } from '../events/drag.js';
import { add } from '../utils.js';
import { MaplibreObject } from './base.js';
export class MaplibreMarker extends MaplibreObject {
    #marker;
    constructor(id, marker) {
        super('MarkerObject', id);
        this.#marker = marker;
    }
    get attached() {
        return !!this.#marker;
    }
    remove() {
        if (!this.#marker)
            return;
        this.#marker.remove();
        this.#marker = null;
    }
    get pos() {
        if (!this.#marker)
            return [0, 0];
        return convertLngLatToLatLng(this.#marker.getLngLat());
    }
    setPos(pos) {
        if (!this.#marker)
            return;
        this.#marker.setLngLat(convertLatLngToLngLatLike(pos));
    }
    onEvent(event, callback) {
        const marker = this.#marker;
        if (!marker)
            return () => { };
        const handler = (e) => {
            callback(dragEvent(e.type, convertLngLatToLatLng(marker.getLngLat())));
        };
        marker.on(event, handler);
        return () => {
            marker.off(event, handler);
        };
    }
}
export const addMarker = add('marker', (map, options, id) => {
    if (map._removed)
        throw new Error('Map is removed');
    const marker = new Marker({ element: options.element });
    marker.setLngLat(convertLatLngToLngLatLike(options.pos));
    marker.setDraggable(options.draggable ?? defaultMarkerOptions.draggable);
    marker.addTo(map);
    const markerObj = new MaplibreMarker(id, marker);
    return markerObj;
});
//# sourceMappingURL=data:application/json;base64,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